import {
  STORAGE_SCHEMA_VERSION,
  STORAGE_VERSION_KEY,
  WEB_AUTH_STORAGE_KEYS,
  WEB_STALE_STORAGE_KEYS,
  WEB_STALE_STORAGE_PREFIXES,
  isStorageStale,
  shouldClearSessionForClaims,
} from "@horseed/shared";


function removeKey(key) {
  try {
    localStorage.removeItem(key);
  } catch (_) {
    /* ignore storage errors */
  }
}

/**
 * A session issued before the migration carries an integer `userId` claim, which
 * would be posted to the order API as a malformed Guid. Such a session cannot be
 * repaired client-side, so it is dropped and the user signs in again.
 */
function clearPreMigrationSession() {
  let claims = null;
  try {
    const raw = localStorage.getItem("auth_claims");
    claims = raw ? JSON.parse(raw) : null;
  } catch (_) {
    claims = null;
  }

  if (!claims) return;

  if (shouldClearSessionForClaims(claims)) {
    WEB_AUTH_STORAGE_KEYS.forEach(removeKey);
  }
}

/**
 * One-time purge of persisted state written before entity ids became GUIDs.
 * Safe to call on every startup — it no-ops once the version marker is current.
 */
export function runStorageMigration() {
  if (typeof window === "undefined") return false;

  let stored = null;
  try {
    stored = localStorage.getItem(STORAGE_VERSION_KEY);
  } catch (_) {
    return false; // storage unavailable (private mode); nothing to migrate
  }

  if (!isStorageStale(stored)) return false;

  WEB_STALE_STORAGE_KEYS.forEach(removeKey);

  try {
    Object.keys(localStorage)
      .filter((key) => WEB_STALE_STORAGE_PREFIXES.some((prefix) => key.startsWith(prefix)))
      .forEach(removeKey);
  } catch (_) {
    /* ignore enumeration errors */
  }

  clearPreMigrationSession();

  try {
    localStorage.setItem(STORAGE_VERSION_KEY, String(STORAGE_SCHEMA_VERSION));
  } catch (_) {
    /* ignore storage errors */
  }

  return true;
}
